import DropdownLinks from "./dropdown-links";

class WizardSelector {
    constructor() {
    }

    init() {
        this.wizardSelectorContainer = document.querySelector('.wizard-selector');
        this.gradientContainer = document.querySelector('.gradient-container');
        this.titles = document.getElementsByClassName('level-title');
        this.attachEvents();

        if (DeviceHelper.isMobilebrowser()
            && screen.width < 900
            && screen.height < 900) {
            this.createMobileSelector();
        }
    }

    attachEvents() {
        var matchMediaMobile = window.matchMedia('(max-width: 991px)');
        if (matchMediaMobile) {
            if (matchMediaMobile.addEventListener) {
                matchMediaMobile.addEventListener('change', event => {
                    this.matchMediaChanged(event);
                });
            } else if (matchMediaMobile.addListener) {
                matchMediaMobile.addListener('change', event => {
                    this.matchMediaChanged(event);
                });
            }
        }

        for (let i = 0; i < this.titles.length; i++) {
            this.titles[i].addEventListener('click', function () {
                var id = this.getAttribute('id');
                this.classList.add('active');
                var panel = document.querySelector(`.level-panel#${id}`);
                if (panel.style.display === 'block') {
                    if (!panel.classList.contains('level-two')) {
                        var openedPanels = document.querySelectorAll('.level-panel.opened');
                        openedPanels.forEach((openedPanel) => {
                            openedPanel.classList.remove('opened');
                            openedPanel.style.display = 'none';
                        });

                        var activeHeadings = document.querySelectorAll('.level-title.active');
                        activeHeadings.forEach((activeheading) => {
                            activeheading.classList.remove('active');
                        });
                    } else {
                        panel.classList.remove('opened');
                        panel.style.display = 'none';
                        this.classList.remove('active');
                    }
                } else {
                    var openedPanels = document.querySelectorAll('.level-panel.opened');
                    if (openedPanels.length > 0) {
                        if (openedPanels.length === 1) {
                            if (openedPanels[0].classList[1] === panel.classList[1]) {
                                openedPanels[0].classList.remove('opened');
                                openedPanels[0].style.display = 'none';
                                var activeHeadings = document.querySelectorAll('.level-title.active');
                                if (!activeHeadings[0].isEqualNode(this)) {
                                    activeHeadings[0].classList.remove('active');
                                } else {
                                    activeHeadings[1].classList.remove('active');
                                }
                                panel.classList.add('opened');
                                panel.style.display = 'block';
                            } else {
                                panel.classList.add('opened');
                                panel.style.display = 'block';
                                this.classList.add('active');
                            }
                        }
                        if (openedPanels.length === 2) {
                            var level = panel.classList[1];
                            if (level === 'level-one') {
                                openedPanels.forEach((openedPanel) => {
                                    openedPanel.classList.remove('opened');
                                    openedPanel.style.display = 'none';
                                });
                                var activeHeadings = document.querySelectorAll('.level-title.active');
                                activeHeadings.forEach((activeheading) => {
                                    activeheading.classList.remove('active');
                                });
                                this.classList.add('active');
                            } else {
                                openedPanels.forEach((openedPanel) => {
                                    if (openedPanel.classList.contains('level-two')) {
                                        openedPanel.classList.remove('opened');
                                        openedPanel.style.display = 'none';
                                    }
                                });
                                var activeHeadings = document.querySelectorAll('.level-title.active');
                                if (!activeHeadings[1].isEqualNode(this)) {
                                    activeHeadings[1].classList.remove('active');
                                } else {
                                    activeHeadings[2].classList.remove('active');
                                }
                            }

                            panel.classList.add('opened');
                            panel.style.display = 'block';
                        }
                    } else {
                        panel.classList.add('opened');
                        panel.style.display = 'block';
                    }
                }

                var levels = document.querySelectorAll('.level-container');
                levels.forEach((level) => {
                    if (level.querySelectorAll('.active').length > 0) {
                        level.classList.add('is-active');
                    } else {
                        if (level.classList.contains('is-active')) {
                            level.classList.remove('is-active');
                        }
                    }
                });
            });
        }
    }

    attachMobileEvents() {
        var mobileContainer = document.querySelector('.wizard-selector__mobile');
        var mobileTitles = mobileContainer.getElementsByClassName('level-title');
        for (let i = 0; i < mobileTitles.length; i++) {
            mobileTitles[i].addEventListener('click', function () {
                var id = this.getAttribute('id');
                this.classList.add('active');
                var panel = mobileContainer.querySelector(`.level-panel#${id}`);
                if (panel.style.display === 'block') {
                    if (!panel.classList.contains('level-two')) {
                        var openedPanels = mobileContainer.querySelectorAll('.level-panel.opened');
                        openedPanels.forEach((openedPanel) => {
                            openedPanel.classList.remove('opened');
                            openedPanel.style.display = 'none';
                        });

                        var activeHeadings = mobileContainer.querySelectorAll('.level-title.active');
                        activeHeadings.forEach((activeheading) => {
                            activeheading.classList.remove('active');
                        });
                    } else {
                        panel.classList.remove('opened');
                        panel.style.display = 'none';
                        this.classList.remove('active');
                    }
                } else {
                    var openedPanels = mobileContainer.querySelectorAll('.level-panel.opened');
                    if (openedPanels.length > 0) {
                        if (openedPanels.length === 1) {
                            if (openedPanels[0].classList[1] === panel.classList[1]) {
                                openedPanels[0].classList.remove('opened');
                                openedPanels[0].style.display = 'none';
                                var activeHeadings = mobileContainer.querySelectorAll('.level-title.active');
                                if (!activeHeadings[0].isEqualNode(this)) {
                                    activeHeadings[0].classList.remove('active');
                                } else {
                                    activeHeadings[1].classList.remove('active');
                                }
                                panel.classList.add('opened');
                                panel.style.display = 'block';
                            } else {
                                panel.classList.add('opened');
                                panel.style.display = 'block';
                                this.classList.add('active');
                            }
                        }
                        if (openedPanels.length === 2) {
                            var level = panel.classList[1];
                            if (level === 'level-one') {
                                openedPanels.forEach((openedPanel) => {
                                    openedPanel.classList.remove('opened');
                                    openedPanel.style.display = 'none';
                                });
                                var activeHeadings = mobileContainer.querySelectorAll('.level-title.active');
                                activeHeadings.forEach((activeheading) => {
                                    activeheading.classList.remove('active');
                                });
                                this.classList.add('active');
                            } else {
                                openedPanels.forEach((openedPanel) => {
                                    if (openedPanel.classList.contains('level-two')) {
                                        openedPanel.classList.remove('opened');
                                        openedPanel.style.display = 'none';
                                    }
                                });
                                var activeHeadings = mobileContainer.querySelectorAll('.level-title.active');
                                if (!activeHeadings[1].isEqualNode(this)) {
                                    activeHeadings[1].classList.remove('active');
                                } else {
                                    activeHeadings[2].classList.remove('active');
                                }
                            }

                            panel.classList.add('opened');
                            panel.style.display = 'block';
                        }
                    } else {
                        panel.classList.add('opened');
                        panel.style.display = 'block';
                    }
                }

                var glide = mobileContainer.querySelector('.level-panel.opened .wizard-glide');
                if (glide) {
                    var mount = new window.Glide(glide, {
                        type: 'slider',
                        startAt: 0,
                        perView: 1,
                        peek: {
                            before: 0,
                            after: 50
                        },
                        gap: 0,
                        arrows: {
                            prev: '.glide__arrow--prev',
                            next: '.glide__arrow--next'
                        },
                        keyboard: false,
                        dragThreshold: false
                    }).mount();

                    glide.querySelector('.glide-controls').style.display = 'block';
                    var lazyImages = [].slice.call(glide.querySelectorAll("[data-src]"));
                    lazyImages.forEach(function (image) {
                        image.setAttribute('src', image.getAttribute('data-src'));
                    });
                }

                var levels = mobileContainer.querySelectorAll('.level-container');
                levels.forEach((level) => {
                    if (level.querySelectorAll('.active').length > 0) {
                        level.classList.add('is-active');
                    } else {
                        if (level.classList.contains('is-active')) {
                            level.classList.remove('is-active');
                        }
                    }
                });
            });
        }
    }

    matchMediaChanged(event) {
        if (event.matches) {
            this.createMobileSelector();
        } else {
            document.querySelector('.wizard-selector__mobile').style.display = 'none';
            this.gradientContainer.style.display = 'block';
        }
    }

    createMobileSelector() {
        this.gradientContainer.style.display = 'none';
        if (document.querySelector('.wizard-selector__mobile')) {
            document.querySelector('.wizard-selector__mobile').style.display = 'block';
        } else {
            var wizardButtonMobile = this.wizardSelectorContainer.querySelector('.wizard-button__mobile');
            if (wizardButtonMobile) {
                wizardButtonMobile.insertAdjacentHTML('beforebegin', '<div class="wizard-selector__mobile"></div>');
            }
            else {
                this.gradientContainer.insertAdjacentHTML('afterend', '<div class="wizard-selector__mobile"></div>');
            }
            var mobileDiv = this.wizardSelectorContainer.querySelector('.wizard-selector__mobile');

            // Adding first level heading
            var levelHeadings = this.gradientContainer.querySelectorAll('.levelOne-h4');
            mobileDiv.insertAdjacentHTML('beforeend', levelHeadings[0].outerHTML);

            // Adding first level titles
            mobileDiv.insertAdjacentHTML('beforeend', '<div class="level-container"></div>');
            var levelContainers = this.gradientContainer.querySelectorAll('.level-container');
            var firstLevelTitles = levelContainers[0].querySelectorAll('.card-step-title').length > 0 ? levelContainers[0].querySelectorAll('.card-step-title') : levelContainers[0].querySelectorAll('.level-title');
            let counter = 1;
            firstLevelTitles.forEach((title) => {
                if (title.classList.contains('card-step-title')) {
                    mobileDiv.querySelector('.level-container').insertAdjacentHTML('beforeend', `<a id="levelOne-${counter}" class="level-title">${title.outerHTML}</a>`);
                } else {
                    mobileDiv.querySelector('.level-container').insertAdjacentHTML('beforeend', title.outerHTML);
                }
                mobileDiv.insertAdjacentHTML('beforeend', `<div id="levelOne-${counter}" class="level-panel level-one"><div class="level-container"></div></div>`);
                counter++;
            });

            // Adding second level titles
            var secondLevelContainers = mobileDiv.querySelectorAll('.level-one .level-container');
            var secondCounter = 1;
            var thirdCounter = 1;
            secondLevelContainers.forEach((container) => {
                container.setAttribute("role", "tablist");
                container.insertAdjacentHTML('beforeend', `<div class="dropdown-links" role="tab"><div class="helN-rom helN-rom-h6 levelOne-h6 color-darkblue">${levelHeadings[1].innerHTML}</div><div class="select-text hidden">${levelHeadings[1].innerHTML}</div><svg xmlns="http://www.w3.org/2000/svg" id="icon-arrow-down" viewBox="0 0 16 10" width="16" height="10"><path d="M 7.38 9.733 L 0.259 2.4 C -0.087 2.044 -0.087 1.477 0.259 1.12 L 1.089 0.266 C 1.426 -0.089 1.992 -0.089 2.329 0.266 L 8 6.074 L 13.67 0.266 C 14.008 -0.089 14.573 -0.089 14.911 0.266 L 15.741 1.12 C 16.086 1.477 16.086 2.044 15.741 2.4 L 8.62 9.733 C 8.283 10.088 7.717 10.088 7.38 9.733 Z"></path></svg><ul class="dropdown-links__links"></ul></div>`);
                var secondLevelTitles = levelContainers[secondCounter].querySelectorAll('.card-step-title').length > 0 ? levelContainers[secondCounter].querySelectorAll('.card-step-title') : levelContainers[secondCounter].querySelectorAll('.level-title');
                secondLevelTitles.forEach((title) => {
                    if (title.classList.contains('card-step-title')) {
                        container.querySelector('.dropdown-links ul').insertAdjacentHTML('beforeend', `<li><a id="levelTwo-${thirdCounter}" class="level-title">${title.outerHTML}</a></li>`);
                    } else {
                        container.querySelector('.dropdown-links ul').insertAdjacentHTML('beforeend', `<li>${title.outerHTML}</li>`);
                    }
                    mobileDiv.insertAdjacentHTML('beforeend', `<div id="levelTwo-${thirdCounter}" class="level-panel level-two"><div class="wizard-glide"><div class="glide__track" data-glide-el="track"><ul class="glide__slides"></ul></div></div></div>`);
                    thirdCounter++;
                });
                secondCounter++;
            });

            var lastCounter = 0;
            var thirdLevelContainers = mobileDiv.querySelectorAll('.level-two .glide__slides');
            thirdLevelContainers.forEach((container) => {
                //container.insertAdjacentHTML('beforeend', '<li class="glide__slide"></li>');
                var thirdLevelRow = this.gradientContainer.querySelectorAll('.level-two .row');
                for (let i = 0; i < thirdLevelRow[lastCounter].children.length - 1; i++) {
                    container.insertAdjacentHTML('beforeend', `<li class="glide__slide">${thirdLevelRow[lastCounter].children[i].outerHTML}</li>`);
                }
                container.parentElement.parentElement.insertAdjacentHTML('beforeend', `${thirdLevelRow[lastCounter].querySelector('.glide-controls').outerHTML}`);
                lastCounter++;
            });

            this.attachMobileEvents();
            this.dropdownLinks = new DropdownLinks();
            var firstItem = document.querySelector('.wizard-selector__mobile .level-title');
            firstItem.click();
        }
    }
}
export default WizardSelector;